export default "__VITE_ASSET__3uMxbrPS__"